// shared-types/src/payment/types.ts

import { Currency } from "../common";

export enum PaymentStatus {
    PENDING = 'PENDING', // Pendiente
    PREAUTHORIZED = 'PREAUTHORIZED',
    APPROVED = 'APPROVED', // Pago aprobado online
    PAID = 'PAID', // Pago realizado por redes fisicas
    REJECTED = 'REJECTED', // Pago rechazado
    REFUND_IN_PROCESS = 'REFUND_IN_PROCESS', // En proceso de reembolso con la plataforma de pagos
    PARTIAL_REFUND = 'PARTIAL_REFUND', // Pago parcialmente reembolsado
    REFUNDED = 'REFUNDED', // Pago reembolsado
}

export enum PaymentMethodType {
    BANK_TRANSFER = 'BANK_TRANSFER',
    CREDIT_CARD = 'CREDIT_CARD',
    DEBIT_CARD = 'DEBIT_CARD',
    MERCADOPAGO = 'MERCADOPAGO',
    PHYSICAL = 'PHYSICAL',
    INTERNATIONAL = 'INTERNATIONAL',
    PAYPAL = 'PAYPAL',
    CASH = 'CASH',
    OTHER = 'OTHER', // Added for flexibility
}

export interface Payment {
  id: string;
  accountId: string;
  orderId: string;
  invoiceId?: string;
  gatewayPaymentId?: string;
  referenceCode?: string;
  paymentMethodType?: PaymentMethodType;
  currency: Currency;
  amount: number;
  amountReceived: number;
  amountRefunded: number;
  paidAt?: string | Date;
  refundedAt?: string | Date;
  status: PaymentStatus;
  cardBrand?: string;
  cardLast4?: string;
  metadata?: Record<string, any>;
  demo: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  deletedAt?: string | Date;
}